import _TextList from './TextList';
import TextListItem from './TextListItem';
import withData from './withData';
import withLimit from './withLimit';

export const LegacyTextList = withData(withLimit(_TextList)); // eslint-disable-line
export const LegacySimpleTextList = _TextList;
LegacyTextList.Item = TextListItem;

export default LegacyTextList;
